import { isNotNullish, isNullish } from '@y42/util/nullish';
import * as go from 'gojs';
import { IS_SIDEBAR_TYPE_PROP } from './../../common/config/common-prop-names';
import { linkTemplate } from './../link';
import {
  restoreTemporaryPortStroke,
  setTemporaryPortStroke,
  sidebarLinkingToolIsValidFrom,
  sidebarLinkingToolIsValidTo,
} from './linking-utils';

export const linkOverrideRelinkingTool = (diagram: go.Diagram, category: string) => {
  const relinkingTool = diagram.toolManager.relinkingTool;

  overrideRelinking(category, relinkingTool);
};

const overrideRelinking = (linkCategory: string, tool: go.RelinkingTool) => {
  const originalUnconnectedLinkValid = tool.isUnconnectedLinkValid;
  const doActivateBase = tool.doActivate.bind(tool);
  const doDeactivateBase = tool.doDeactivate.bind(tool);
  const isValidFromBase = tool.isValidFrom.bind(tool);
  const isValidToBase = tool.isValidTo.bind(tool);

  tool.doActivate = () => {
    const originalLink = findRelinkingLink(tool);
    if (originalLink?.data[IS_SIDEBAR_TYPE_PROP]) {
      tool.temporaryLink = linkTemplate();
      tool.isUnconnectedLinkValid = true;
      setTemporaryPortStroke(tool);
      if (tool.temporaryFromPort instanceof go.Shape && originalLink?.fromPort instanceof go.Shape) {
        tool.temporaryFromPort.figure = originalLink.fromPort.figure;
        tool.temporaryFromPort.geometryString = originalLink.fromPort.geometryString;
      }
    }

    doActivateBase();
  };
  tool.doDeactivate = () => {
    doDeactivateBase();
    tool.isUnconnectedLinkValid = originalUnconnectedLinkValid;
    restoreTemporaryPortStroke(tool);
  };

  tool.isValidFrom = isValidFrom(tool, isValidFromBase);
  tool.isValidTo = isValidTo(tool, isValidToBase);
};

const isValidFrom =
  (tool: go.RelinkingTool, isValidFromBase: (toNode: go.Node, fromPort: go.GraphObject) => boolean) =>
  (fromNode: go.Node, fromPort: go.GraphObject) => {
    if (isNullish(tool.originalLink)) {
      tool.originalLink = findRelinkingLink(tool);
    }
    if (!tool.originalLink?.data[IS_SIDEBAR_TYPE_PROP]) {
      return isValidFromBase.call(tool, fromNode, fromPort);
    }
    return sidebarLinkingToolIsValidFrom(tool)(fromNode, fromPort);
  };

const isValidTo =
  (tool: go.RelinkingTool, isValidToBase: (toNode: go.Node, toPort: go.GraphObject) => boolean) =>
  (toNode: go.Node, toPort: go.GraphObject) => {
    if (isNullish(tool.originalLink)) {
      tool.originalLink = findRelinkingLink(tool);
    }
    if (!tool.originalLink?.data[IS_SIDEBAR_TYPE_PROP]) {
      return isValidToBase.call(tool, toNode, toPort);
    }

    return sidebarLinkingToolIsValidTo(tool)(toNode, toPort);
  };

const findRelinkingLink = (tool: go.RelinkingTool) => {
  if (isNotNullish(tool.originalLink)) {
    return tool.originalLink;
  } else {
    const handle =
      tool.handle ||
      tool.findToolHandleAt(tool.diagram.firstInput.documentPoint, 'RelinkFrom') ||
      tool.findToolHandleAt(tool.diagram.firstInput.documentPoint, 'RelinkTo');
    const link = (handle?.part as go.Adornment)?.adornedPart;
    return link instanceof go.Link ? link : null;
  }
};
